import { SimplePool } from "@jsr/nostr__tools/pool";
import { MemoryHints } from "./hints.js";
import { Purgatory } from "./purgatory.js";
import { defaultReplaceableStore } from "./replaceable-store.js";
export const purgatory = new Purgatory();
/**
 * pool is a global used by all other functions in this library. Feel free to use it directly in your app.
 */ export let pool = new SimplePool({
  allowConnectingToRelay: purgatory.allowConnectingToRelay.bind(purgatory),
  onRelayConnectionFailure: purgatory.onRelayConnectionFailure.bind(purgatory),
  onRelayConnectionSuccess: purgatory.onRelayConnectionSuccess.bind(purgatory)
});
/**
 * setPool sets the global pool -- do not use unless you know what you're doing.
 */ export function setPool(p) {
  pool = p;
}
/**
 * hints is a global used by other functions in this library. Use it directly.
 */ export const hints = new MemoryHints();
/**
 * replaceableStore is a global store used for caching replaceable Nostr events.
 * By default, it uses localStorage.
 */ export let replaceableStore = defaultReplaceableStore;
/**
 * setReplaceableStore sets the global replaceable store.
 */ export function setReplaceableStore(store) {
  replaceableStore = store;
}
//# sourceMappingURL=global.js.map